interface StatusBadgeProps {
  status: string;
}

export default function StatusBadge({ status }: StatusBadgeProps) {
  const styleMap: Record<string, string> = {
    跟进中: 'bg-accent-100 text-accent-900 border-accent-200',
    有新进展: 'bg-primary-100 text-primary-800 border-primary-200',
    已归档: 'bg-secondary-100 text-secondary-900 border-secondary-200',
  };

  const style = styleMap[status] || 'bg-background-200 text-foreground-700 border-background-300';

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-[11px] font-medium tracking-wide whitespace-nowrap ${style}`}
    >
      <i className="ri-pulse-line text-xs"></i>
      {status}
    </span>
  );
}